var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.948,
    height: 33.264,
    viewBox: "0 0 24.948 33.264",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "file-invoice",
    d: "M18.711,16.632H6.237V20.79H18.711Zm5.782-9.81L18.133.455A1.558,1.558,0,0,0,17.029,0h-.4V8.316h8.316v-.4A1.554,1.554,0,0,0,24.494,6.822Zm-9.94,2.014V0H1.559A1.556,1.556,0,0,0,0,1.559V31.705a1.556,1.556,0,0,0,1.559,1.559h21.83a1.556,1.556,0,0,0,1.559-1.559V10.4H16.112A1.564,1.564,0,0,1,14.553,8.836ZM4.158,4.678a.52.52,0,0,1,.52-.52h5.2a.52.52,0,0,1,.52.52v1.04a.52.52,0,0,1-.52.52h-5.2a.52.52,0,0,1-.52-.52Zm0,4.158a.52.52,0,0,1,.52-.52h5.2a.52.52,0,0,1,.52.52v1.04a.52.52,0,0,1-.52.52h-5.2a.52.52,0,0,1-.52-.52ZM20.79,28.587a.52.52,0,0,1-.52.52h-5.2a.52.52,0,0,1-.52-.52v-1.04a.52.52,0,0,1,.52-.52h5.2a.52.52,0,0,1,.52.52Zm0-12.994V21.83a1.039,1.039,0,0,1-1.04,1.04H5.2a1.039,1.039,0,0,1-1.04-1.04V15.593a1.039,1.039,0,0,1,1.04-1.04H19.751A1.039,1.039,0,0,1,20.79,15.593Z",
    fill: "#fcc02a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.5910d7d7051aec3d316d261407ddff27.svg";
export { ForwardRef as ReactComponent };